// @flow

import * as React from 'react'
import { Grid, Segment, Button, Message, Label } from 'semantic-ui-react'
import { Form, formActions, Validators, Fields } from 'react-redux-components'
import { connect, type Connector } from 'react-redux'
import { login, type LoginForm as LoginFormType } from './store/authentication'

import './login-form.css'
import logo from './CLARA.svg'
import type { ReduxState, Dispatch } from './store'

type OwnProps = {||}

type MappedProps = {|
  status: string,
  error: Object,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  return {
    status: state.auth.data.status,
    error: state.auth.data.error,
  }
}

type Props = { dispatch: Dispatch } & MappedProps & OwnProps

class LoginForm extends React.Component<Props> {
  static defaultProps = {}

  username: ?HTMLInputElement

  validators = {
    username: { required: Validators.required },
    password: { required: Validators.required },
  }

  componentDidMount() {
    this.props.dispatch(formActions.reset('auth.form'))
    if (this.username) this.username.focus()
  }

  handleFormOnSubmit = (values: LoginFormType) => {
    this.props.dispatch(login(values))
  }

  render() {
    return (
      <div>
        <Grid verticalAlign={'middle'} centered>
          <div className="ui row" style={{ height: '96vh' }}>
            <div className="six wide column">
              <Segment>
                <Label attached="top" color="blue" size="big">
                  Accedi al sistema
                </Label>
                <Grid verticalAlign={'middle'} centered style={{ marginBottom: '5ex' }}>
                  <div className="ui row">
                    <div className="eight wide column">
                      <img src={logo} alt="CLARA logo" />
                    </div>
                    <div className="seven wide column">
                      <div style={{ height: '2ex' }} />
                      <Form
                        model="auth.form"
                        className="ui form center"
                        onSubmit={this.handleFormOnSubmit}
                        validators={this.validators}>
                        <Fields.TextInput
                          label="Username"
                          model=".username"
                          errorMessages={{
                            required: 'Campo obbligatorio.',
                          }}
                          rawField={(field: HTMLInputElement) => {
                            this.username = field
                          }}
                        />
                        <Fields.PasswordInput
                          label="Password"
                          model=".password"
                          errorMessages={{
                            required: 'Campo obbligatorio.',
                          }}
                        />
                        <Button
                          primary
                          loading={this.props.status === 'LOGIN_PENDING'}
                          type="submit"
                          className="fluid large ">
                          Accedi
                        </Button>
                      </Form>
                    </div>
                  </div>
                  <div className="ui row" style={{ padding: 0 }}>
                    <div className="column">
                      <Message
                        style={{ marginBottom: '1rem' }}
                        hidden={this.props.status !== 'LOGIN_ERROR' && this.props.status !== 'TOKEN_EXPIRED'}
                        negative>
                        <Message.Header>{this.props.error.title}</Message.Header>
                        <p>{this.props.error.message}</p>
                      </Message>
                    </div>
                  </div>
                </Grid>
                <Label className="brand" attached="bottom" size="small">
                  <b className="brand-cap">C</b>hannel <b className="brand-cap">L</b>eads <b className="brand-cap">A</b>ctivity
                  & <b className="brand-cap">R</b>eport <b className="brand-cap">A</b>ssistant
                </Label>
              </Segment>
            </div>
          </div>
        </Grid>
      </div>
    )
  }
}
const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(LoginForm)



// WEBPACK FOOTER //
// ./src/login-form.js